// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2osmY","list":"styles_list__17UZ4"};